"use client";

import { ShieldCheck, Truck, BadgeCheck } from "lucide-react";
import { WooCommerceCheckoutBlock } from "@/integrations/wordpress/WooCommerceCheckoutBlock";
export default function Checkout() {
  const steps = [{
    num: "01",
    label: "CART"
  }, {
    num: "02",
    label: "CHECKOUT"
  }, {
    num: "03",
    label: "CONFIRMATION"
  }];
  const trustSignals = [{
    icon: ShieldCheck,
    label: "SECURE DONATION"
  }, {
    icon: Truck,
    label: "ETHICAL SHIPPING"
  }, {
    icon: BadgeCheck,
    label: "IMPACT GUARANTEE"
  }];
  return <section data-section-id="2719" id="checkout-content" className="bg-[#fcfaf5] text-[#0a1f1a] pt-[120px] pb-24 px-4 sm:px-6 lg:px-12">
      <div className="max-w-7xl mx-auto">
        {}
        <div className="flex flex-wrap items-center gap-4 sm:gap-8 mb-12 border-b border-[#dcd6c8] pb-6">
          {steps.map((step, i) => {
          const isActive = step.label === "CHECKOUT";
          return <div data-index={i} key={step.num} className="flex items-center gap-3">
                <span className={`font-mono text-xs tracking-widest ${isActive ? "text-[#0a1f1a]" : "text-[#8a8578]"}`}>
                  {step.num}
                </span>
                <span className={`font-default text-xs tracking-widest font-semibold ${isActive ? "text-[#0a1f1a]" : "text-[#8a8578]"}`}>
                  {step.label}
                </span>
                {i < steps.length - 1 && <span className="ml-4 sm:ml-8 h-px w-8 sm:w-16 bg-[#dcd6c8]" />}
              </div>;
        })}
        </div>

        {}
        <div className="mb-12">
          <h1 className="font-default text-5xl sm:text-6xl lg:text-7xl font-bold tracking-tighter leading-[0.95]">
            Final{" "}
            <span className="font-serif italic font-light text-[#8a8578]">
              / mission.
            </span>
          </h1>
          <p className="mt-4 font-default text-base sm:text-lg text-[#4a5d58] max-w-2xl">
            Complete your contribution below. Your support directly funds our awareness initiatives and humanitarian outreach.
          </p>
        </div>

        {}
        <div className="backdrop-blur-sm bg-[#fcfaf5]/80 border border-[#dcd6c8] p-6 sm:p-10 rounded-lg" style={{
        boxShadow: "var(--shadow-lg)"
      }}>
          <WooCommerceCheckoutBlock />
        </div>

        {}
        <div className="mt-10 grid grid-cols-1 sm:grid-cols-3 gap-4">
          {trustSignals.map((signal, i) => {
          const Icon = signal.icon;
          return <div data-index={i} key={signal.label} className="backdrop-blur-sm bg-[#fcfaf5]/50 border border-[#dcd6c8] px-5 py-4 flex items-center gap-3 rounded-lg">
                <Icon className="w-5 h-5 text-[#4a8a78]" />
                <span className="font-default text-xs tracking-widest font-medium text-[#0a1f1a]">
                  {signal.label}
                </span>
              </div>;
        })}
        </div>
      </div>
    </section>;
}